import CodeBlockPicker from "./CodeBlockPicker";
import { fetchCodeBlockTemplate } from "../utils/BlueprintEditorAPIClient";
import { showErrorToast } from "../../shared/Toasts";
import useBlueprintContext from "../context/useBlueprintContext";
import { BlueprintStepType, AddStepRelation } from "../../../models/Blueprints";

interface Props {
  newStepRelation: AddStepRelation;
  relatedStepID: string;
  pathKey: string | undefined;
}

const CodeBlockStepCreator = ({ newStepRelation, relatedStepID, pathKey }: Props) => {
  const { stepTemplates, addStep, codeBlockBranch } = useBlueprintContext();

  return (
    <CodeBlockPicker
      onSelect={(codeBlockName, version) => {
        // Fetch the specific template for this code block
        fetchCodeBlockTemplate({
          blockName: codeBlockName,
          versionName: version,
          branch: codeBlockBranch,
          onSuccess: (template) => {
            // Preserve the base template ID from stepTemplates
            const baseTemplate = stepTemplates.find(
              (t) => t.step_type === BlueprintStepType.CodeBlock
            );
            if (baseTemplate) {
              const updatedTemplate = {
                ...template,
                id: baseTemplate.id,
                name: baseTemplate.name,
              };
              // Add the step with the specific template
              addStep(updatedTemplate, newStepRelation, relatedStepID, pathKey);
            }
          },
          onError: () => {
            showErrorToast(`Failed to fetch template for ${codeBlockName} version ${version}`);
          },
        });
      }}
    />
  );
};

export default CodeBlockStepCreator;
